import { chain } from "lodash";
import { CustomFieldsMap, InvestorRequestType, RequiredFieldsPath } from "@investorRequest/models";
import FeatureToggleService from "@services/FeatureToggleService";
import { ToggledFeature } from "@shared/models/featureToggle";

/**
 * Business Exception: Hardcoded Internal Funds Allowlist
 * These specific internal funds bypass the fundraisingStatus/entityType check
 * and are always eligible for Wire Instructions.
 *
 * Funds included:
 * - Carlyle Carried Interest (F000122524)
 * - Carlyle Equity Pool (F000122525)
 * - Carlyle Internal Coinvestment (F000122526)
 * - Carlyle Holdings Units (F000122523)
 */
export const WIRE_INSTRUCTIONS_INTERNAL_FUNDS_ALLOWLIST = [
  "F000122524",
  "F000122525",
  "F000122526",
  "F000122523",
] as const;

const legacyWireCustomFields = {
  bankName: "",
  beneficiaryAccountName: "",
  bankCountry: "",
  bankAccountNumber: "",
  routingNumber: "",
  effectiveDate: "",
};

const expandedWireCustomFields = {
  ...legacyWireCustomFields,
  beneficiaryBankCountry: "",
  paymentMethod: "",
  furtherCreditYesNo: "no",
  furtherCreditLine1: "",
  furtherCreditLine2: "",
  swiftCode: "",
  intermediaryYesNo: "no",
  intermediarySwiftOrAba: "",
  intermediaryBankCountry: "",
  intermediaryBankName: "",
  intermediaryRoutingNumber: "",
  intermediaryPaymentMessage: "",
  freeText: "",
  SwiftId: "",
  IBAN: "",
  BankIdNbr: "",
  BranchId: "",
};

const isExpandedWireEnabled = FeatureToggleService.isFeatureEnabled(ToggledFeature.ExpandedWireInstructions);

export const customFieldsMap: CustomFieldsMap = {
  [InvestorRequestType.General]: {},
  [InvestorRequestType.UpdateWireInstructions]: isExpandedWireEnabled
    ? expandedWireCustomFields
    : legacyWireCustomFields,
  [InvestorRequestType.NoData]: {},
};

export const requiredFieldsPath: RequiredFieldsPath = {
  [InvestorRequestType.General]: ["commonFields.message"],
  [InvestorRequestType.UpdateWireInstructions]: isExpandedWireEnabled
    ? ["commonFields.selectedFunds", "commonFields.selectedAccounts", "customFields.paymentMethod"]
    : [
        "commonFields.message",
        "commonFields.selectedFunds",
        "commonFields.selectedAccounts",
        ...chain(legacyWireCustomFields)
          .omit("effectiveDate")
          .keys()
          .map((field) => `customFields.${field}`)
          .value(),
      ],
  [InvestorRequestType.NoData]: ["commonFields.message"],
};

export const investorRequestTypeTextMap = {
  [InvestorRequestType.General]: "Information Request/General Support",
  [InvestorRequestType.UpdateWireInstructions]: "Update Wire Instructions",
  [InvestorRequestType.NoData]: "No Data Request",
};
